import FeatherIcon from "feather-icons-react";
import React, { Component } from "react";
import { Col, Container, Media, Row } from "reactstrap";
//Import Footer link
import FooterLinks from "./footer-links";

class Footer extends Component {
  state = {};
  render() {
    return (
      <React.Fragment>
        <footer className="footer">
          <Container>
            <Row>
              <Col lg={4} sm={6}>
                <div>
                  <h5 className="mb-4 footer-list-title">About Agari</h5>
                  <p>
                    AGARI is building the giving layer of the internet with
                    fundraising for all: a place where people, group of people,
                    and charities can champion causes that matter and raise
                    money to make a lasting difference.
                  </p>
                </div>
              </Col>
              <Col lg={{ size: 2, offset: 1 }} sm={6}></Col>
              <Col lg={2} sm={6}></Col>

              <Col lg={3} sm={6}>
                <div>
                  <h5 className="mb-4 footer-list-title">Contact</h5>

                  <div>
                    <Media>
                      <i>
                        <FeatherIcon
                          icon="map-pin"
                          className="icon-dual-light icons-sm mt-1 mr-2"
                        />
                      </i>
                      <Media body>
                        <p>Addis Ababa, Ethiopia</p>
                      </Media>
                    </Media>
                    <Media>
                      <i>
                        <FeatherIcon
                          icon="mail"
                          className="icon-dual-light icons-sm mt-1 mr-2"
                        />
                      </i>
                      <Media body>
                        <p>biruhertachew@gmail.com</p>
                      </Media>
                    </Media>
                    <Media>
                      <i>
                        <FeatherIcon
                          icon="phone"
                          className="icon-dual-light icons-sm mt-1 mr-2"
                        />
                      </i>
                      <Media body>
                        <p>+251-91-855-9191</p>
                      </Media>
                    </Media>
                    <Media>
                      <i>
                        <FeatherIcon
                          icon="phone"
                          className="icon-dual-light icons-sm mt-1 mr-2"
                        />
                      </i>
                      <Media body>
                        <p>+251-93-244-1545</p>
                      </Media>
                    </Media>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </footer>
        {/* Render footer links */}
        <FooterLinks />
      </React.Fragment>
    );
  }
}

export default Footer;
